var cardFunctions = {

	/**
	 * Init
	 *
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	init: function(target) {
		target.addEventListener('click', event => {
			const cardHeader = event.target.closest('.card-header.card-header-collapse');
			if (cardHeader && !event.target.classList.contains('btn')) {
				this.toggleContent(cardHeader);
			}
		});
	},

	/**
	 * Toggle the content of a card
	 *
	 * @param {HTMLElement} cardHeader - The header element of the card
	 *
	 * @returns {void}
	 */
	toggleContent: function(cardHeader) {
		const i = cardHeader.querySelector('.card-header-control i') ?? cardHeader.querySelector('small i'); // Fallback voor card-header-heading, verwijderen na ES6 uitfaseren oud dossier
		const cardBody = cardHeader.closest('.card').querySelector('.card-body');
		i.classList.toggle('fa-chevron-down');
		i.classList.toggle('fa-chevron-left');
		cardBody.style.display = i.classList.contains('fa-chevron-down') ? '' : 'none';
		cardBody.classList.toggle('d-none');
	}

};

export default cardFunctions;
